// extracted by mini-css-extract-plugin
module.exports = {"react-tabs":"styles_react-tabs__E50E1","react-tabs__tab-list":"styles_react-tabs__tab-list__27C2V","react-tabs__tab--selected":"styles_react-tabs__tab--selected__xQa1d"};